import { render, staticRenderFns } from "./AlertAndErrorReport.vue?vue&type=template&id=37489a85&scoped=true"
import script from "./AlertAndErrorReport.vue?vue&type=script&lang=js"
export * from "./AlertAndErrorReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37489a85",
  null
  
)

export default component.exports